import http from '@utils/http'

/**
 * 获取积分商品
 */
export function queryIntegralPlan(data): Promise<any> {
    return http.post('/integral/queryIntegralPlan', data || {})
}

/**
 * 积分商品详情
 */
export function buyIntegralGoodQuery(data): Promise<any> {
    return http.post('/sim/buyIntegralGoodQuery', data || {})
}

/**
 * 账户积分信息
 */
export function detailCustomerIntegral(data): Promise<any> {
    return http.post('/integral/detailCustomerIntegral', data || {})
}

/**
 * 积分使用记录
 */
export function integralRecordList(data): Promise<any> {
    return http.post('/integral/integralRecordList', data || {})
}
/**
 * 创建积分订单
 */
export function buyIntegralGood(data): Promise<any> {
    return http.post('/sim/buyIntegralGood', data || {})
}
/**
 * 积分订单详情
 */
export function queryIntegralOrderStatus(data): Promise<any> {
    return http.post('/sim/queryIntegralOrderStatus', data || {})
}

/**
 * 签到活动
 */
export function querySignInfo(data): Promise<any> {
    return http.post('/sim/querySignInfo', data || {})
}
/**
 * 签到
 */
export function signIn(data): Promise<any> {
    return http.post('/sim/signIn', data || {})
}
